import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-without-animation-home-two',
    templateUrl: './without-animation-home-two.component.html',
    styleUrls: ['./without-animation-home-two.component.scss'],
    standalone: false
})
export class WithoutAnimationHomeTwoComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
